export enum JobType {
  TEXT = "TEXT",
  LINK = "LINK",
}

export enum JobPlatform {
  LINKEDIN = "LINKEDIN",
  JOBKOREA = "JOBKOREA",
  SARAMIN = "SARAMIN",
  WANTED = "WANTED",
  OTHER = "OTHER",
}

export enum JobLanguage {
  UZ = "UZ",
  EN = "EN",
  KR = "KR",
}

export enum JobStatus {
  ACTIVE = "ACTIVE",
  DELETE = "DELETE",
}
